module.exports = __webpack_public_path__ + "static/img/TOBY-SINNEMA.1be1197.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TOBY-SINNEMA.jpg
// module id = KubK
// module chunks = 0